import { GraphQLFormattedError } from 'graphql';

export default function isRateLimited(
  errors: readonly GraphQLFormattedError[] | undefined,
): boolean {
  return errors?.some(({ extensions }) => extensions?.failureReason === 'rate_limited') ?? false;
}
